export default class EventTarget {
    constructor() {
        this.listeners = {};
    }

    addEventListener(type, callback, useCaptureOptions) {
        if (!(type in this.listeners)) {
            this.listeners[type] = [];
        }
        this.listeners[type].push([ callback, useCaptureOptions ]);
        return this.removeEventListener.bind(this, type, callback, useCaptureOptions);
    }

    removeEventListener(type, callback, useCaptureOptions) {
        if (!(type in this.listeners)) {
            return;
        }
        const stack = this.listeners[type];
        for (let i = 0; i < stack.length; i++) {
            const [ cb, uco ] = stack[i];
            if (cb === callback) {
                const useCaptureOptionsKeys = Object.keys(useCaptureOptions);
                const ucoKeys = Object.keys(uco);
                if (useCaptureOptionsKeys.length === ucoKeys.length &&
                    useCaptureOptionsKeys.every(k => useCaptureOptionsKeys[k] === ucoKeys[k])) {
                    stack.splice(i, 1);
                    return;
                }
            }
        }
    }
    
    dispatchEvent(event) {
        if (!(event.type in this.listeners)) {
            return true;
        }
        const stack = this.listeners[event.type].slice();

        for (const [ cb, useCaptureOptions = {} ] of stack) {
            const { capture = (useCaptureOptions === true), once = false, passive = false } = useCaptureOptions;
            cb.call(this, event, {
                capture,
                once,
                passive
            });
            if (once) {
                this.removeEventListener(event.type, cb, useCaptureOptions);
            }
        }
        return !event.defaultPrevented;
    }

}



